import {
  Component,
  OnInit,
  Input,
  ChangeDetectorRef,
  OnDestroy,
} from "@angular/core";
import { fadeInUpAnimation } from "src/@fury/animations/fade-in-up.animation";
import { fadeInRightAnimation } from "src/@fury/animations/fade-in-right.animation";
import { scaleInAnimation } from "src/@fury/animations/scale-in.animation";
import { MatTableDataSource } from "@angular/material/table";
import { MatDialog } from "@angular/material/dialog";
import { ApiService } from "src/app/services/api.service";
import { HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { ContentActionComponent } from "src/app/shared/content-action/content-action.component";
import { ErrorType } from "src/app/enums/error-type.enum";
import { ActivatedRoute, Router } from "@angular/router";
import { Confirmation } from "src/app/enums/confirmation.enum";
import { FormControl, FormGroup } from "@angular/forms";
import { FilterFormModal, FilterValue } from "src/app/models/form-group.model";
import { CommonService } from "src/app/services/common.service";
import endpoints from "src/app/helpers/endpoints";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { EventService } from "src/app/services/event.service";
import { StatusDetailsModalComponent } from "../status-details-modal/status-details-modal.component";

@Component({
  selector: "fury-status-list",
  templateUrl: "./status-list.component.html",
  styleUrls: ["./status-list.component.scss"],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
})
export class StatusListComponent implements OnInit, OnDestroy {
  selectConfig = { disableOptionCentering: true, panelClass: "custom-class" };
  @Input()
  columns = [
    { name: "Status Name", property: "statusName", visible: true },
    { name: "Description", property: "description", visible: true },
    { name: "Actions", property: "actions", visible: true },
  ];
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  itemList: any;
  filterValue: any;
  pageSize = 30;
  totalCount: number = 0;
  pageIndex: number = 0;
  searchedKeyword!: string;
  searchBy: string = "statusName";
  searchType: string = "contains";
  isShowFilter: boolean = false;

  filterForm = new FormGroup<FilterFormModal>({
    searchBy: new FormControl(this.searchBy),
    searchType: new FormControl(this.searchType),
  });

  searchByValue: FilterValue[] = [
    { title: "Status Name", value: "statusName" },
  ];
  ngUnSubscribe = new Subject<void>();

  constructor(
    private apiService: ApiService,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private eventService: EventService,
    public commonService: CommonService
  ) {}
  get visibleColumns() {
    return this.columns
      .filter((column) => column.visible)
      .map((column) => column.property);
  }
  ngOnInit(): void {
    this.filterValue = "Status List";
    this.router.onSameUrlNavigation = "reload";

    this.activatedRoute.queryParams
      .pipe(takeUntil(this.ngUnSubscribe))
      .subscribe((res: any) => {
        this.pageIndex = res.page ? res.page - 1 : 0;
        this.searchedKeyword = res.keywords ? res.keywords : "";
        this.pageSize = res.size ? (res.size === "all" ? 9999 : res.size) : 30;
        this.searchBy = res.searchBy ? res.searchBy : "statusName";
        this.searchType = res.searchType ? res.searchType : "contains";
        this.filterForm.patchValue({
          searchBy: this.searchBy,
          searchType: this.searchType,
        });
        this.getAllStatus();
      });
  }

  ngAfterViewInit(): void {}
  onFilterChange(value: string) {
    this.pageIndex = 0;
    this.searchedKeyword = value.trim();
    this.router.navigateByUrl(
      `/settings/status?page=${this.pageIndex + 1}${
        this.searchedKeyword ? "&keywords=" + this.searchedKeyword : ""
      }${
        this.pageSize
          ? "&size=" + (this.pageSize === 9999 ? "all" : this.pageSize)
          : ""
      }&searchBy=${this.searchBy}&searchType=${this.searchType}`
    );
  }
  pageSizeChange(event: any) {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.router.navigateByUrl(
      `/settings/status?page=${this.pageIndex + 1}${
        this.searchedKeyword ? "&keywords=" + this.searchedKeyword : ""
      }${
        this.pageSize
          ? "&size=" + (this.pageSize === 9999 ? "all" : this.pageSize)
          : ""
      }&searchBy=${this.searchBy}&searchType=${this.searchType}`
    );
  }

  getAllStatus() {
    this.apiService
      .get(
        `${endpoints.settings.statusManagement.getAllStatus}?page=${
          Number(this.pageIndex) + 1
        }&size=${this.pageSize}${
          this.searchedKeyword ? "&keywords=" + this.searchedKeyword : ""
        }&searchBy=${this.searchBy}&searchType=${this.searchType}`
      )
      .pipe(takeUntil(this.ngUnSubscribe))
      .subscribe((res: HttpResponse<any>) => {
        if (res.body) {
          if (res?.body?.claimStatuses) {
            this.itemList = res?.body?.claimStatuses?.data;
            this.eventService.setClaimStatus(this.itemList);
            this.totalCount = res?.body?.claimStatuses.total;
            this.dataSource = new MatTableDataSource(this.itemList);
            this.cdr.detectChanges();
          } else {
            this.itemList = undefined;
          }
        }
      });
  }
  delete(type: string, id: string) {
    const dialogref = this.dialog.open(ContentActionComponent, {
      width: "500px",
      data: { type },
    });
    dialogref
      .afterClosed()
      .pipe(takeUntil(this.ngUnSubscribe))
      .subscribe((res: Confirmation) => {
        if (res === Confirmation.Yes) {
          this.apiService
            .delete(endpoints.settings.statusManagement.deleteStatus(id))
            .pipe(takeUntil(this.ngUnSubscribe))
            .subscribe({
              next: (del: any) => {
                if (del.body) {
                  this.apiService.alert(del.body.message, ErrorType.Success);
                  this.getAllStatus();
                }
              },
              error: (err: HttpErrorResponse) => {
                if (err) {
                  this.apiService.alert(err?.message, ErrorType.Error);
                }
              },
            });
        }
      });
  }

  showFilter() {
    this.isShowFilter = !this.isShowFilter;
  }
  filterChange() {
    this.searchType = this.filterForm.value.searchType;
    this.searchBy = this.filterForm.value.searchBy;
    this.router.navigateByUrl(
      `/settings/status?page=${this.pageIndex + 1}${
        this.searchedKeyword ? "&keywords=" + this.searchedKeyword : ""
      }${
        this.pageSize
          ? "&size=" + (this.pageSize === 9999 ? "all" : this.pageSize)
          : ""
      }&searchBy=${this.searchBy}&searchType=${this.searchType}`
    );
    this.isShowFilter = false;
  }
  openDescriptionModal(data: any){
    const dialogref = this.dialog.open(StatusDetailsModalComponent, {
      width: "500px",
      data,
    });
  }
  ngOnDestroy(): void {
    this.ngUnSubscribe.next();
    this.ngUnSubscribe.complete();
  }
}
